import classnames from 'classnames2';
import React from 'react';

import { IBaseProps } from '../utils';

import styles from './Error.module.scss';

export interface IErrorProps extends IBaseProps {
  /** Defines the id attribute applied to the <p> tag */
  id?: string;
}

export const Error: React.FC<IErrorProps> = (props) => (
  <p id={props.id} className={classnames(styles.error, props.className)} data-test={props.dataTest}>
    {props.children}
  </p>
);
